import React, { useState, useEffect } from 'react';
import { format } from 'date-fns';
import PropTypes from 'prop-types';
import { SelectInput } from '../../../Helpers/Inputs';
import BusinessHours from './BusinessHours';
import BusinessDays from './BusinessDays';
import TimeZones from './Timezones';
import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from '../../../../sessionStorage';
import './Appointment.scss';

export default function Appointment(props) {
  const [appointmentTimes, setAppointmentTimes] = useState([]);
  const [noAppointmentsAvailable, setNoAppointmentsAvailable] = useState(false);
  const [appointmentTimeSelectEnabled, setAppointmentTimeSelectEnabled] = useState(false);
  const covrServicesUrl = window.__ENV__.REACT_APP_COVR_SERVICES_URL;
  const sessionStorage = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
  const oneClickAccountId = sessionStorage && sessionStorage.account && sessionStorage.account.oneClickAccountId;

  useEffect(() => {
    getAvailableAppointments();
  }, [props.apptDate, props.timeZone]);

  const getAppointmentLabel = (date, available) => {
    var label = format(new Date(date), 'p');
    if (!available) {
      label += ' (unavailable)';
    }
    return label;
  };

  const getAvailableAppointments = () => {
    if (props.timeZone === '' || props.apptDate === '' || props.apptDate.includes('_') || props.errors.apptDate) {
      return;
    }
    setAppointmentTimeSelectEnabled(false);
    setNoAppointmentsAvailable(false);
    fetch(`${covrServicesUrl}/api/Case/AvailableAppointments?date=${props.apptDate}&timeZone=${props.timeZone}&oneClickAccountID=${oneClickAccountId}`)
      .then((response) => response.text())
      .then((text) => text ? JSON.parse(text) : [])
      .then((appointments) => {
        if (appointments.length) {
          const appts = appointments.map((a, index) => {
            return {
              value: a.appointment,
              label: getAppointmentLabel(a.appointment, a.available),
              disabled: a.available === false,
            };
          });
          setAppointmentTimes(appts);
          setAppointmentTimeSelectEnabled(true);
        } else {
          setNoAppointmentsAvailable(true);
        }
      });
  };

  return (
    <div className={`p-0`} hidden={props.hide}>
      <div className='mb-3'>
        <SelectInput
          name="timeZone"
          id="timeZone"
          value={props.timeZone}
          onChange={(e) => props.setTimeZone(e.target.value)}
          label="Timezone"
          selectOptions={TimeZones}
        />
      </div>

      <div className='mb-3'>
        <SelectInput
          name="specificApptDate"
          id="specificApptDate"
          value={props.apptDate}
          onChange={(e) => props.setApptDate(e.target.value)}
          label="Date"
          selectOptions={BusinessDays()}
        />
        {noAppointmentsAvailable &&
          <span className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error">No appointment times available on this date.</span>
        }
      </div>

      <div className='mb-0'>
        <SelectInput
          name="specificApptTime"
          id="specificApptTime"
          value={appointmentTimeSelectEnabled ? props.apptTime : ''}
          onChange={(e) => props.setApptTime(e.target.value)}
          disabled={!appointmentTimeSelectEnabled}
          label="Time of Call (Your local time)"
          selectOptions={appointmentTimes}
        />
      </div>
      {!props.hideBusinessHours &&
        <BusinessHours />
      }
    </div>
  );
}

Appointment.propTypes = {
  hide: PropTypes.bool.isRequired,
  timeZone: PropTypes.string.isRequired,
  setTimeZone: PropTypes.func.isRequired,
  apptDate: PropTypes.string.isRequired,
  setApptDate: PropTypes.func.isRequired,
  apptTime: PropTypes.string.isRequired,
  setApptTime: PropTypes.func.isRequired,
};
